import { render } from "./Spinner.vue?vue&type=template&id=02b189f8"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=02b189f8&lang=scss"

import exportComponent from "/Users/andreibratu/Projects/AlibPortfolio/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__